(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["group_image"] && !Shopify.designMode) return;
  try {
    
/* Add your JavaScript code here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product_model"]) return;
  try {
    
document.addEventListener('click', function(e){

if(e.target.closest('.exploded-view-popup-btn')){
    e.preventDefault();
    document
      .querySelector('.exploded-view-modal')
      ?.classList.add('active');
  }

  if(
    e.target.classList.contains('exploded-view-close') ||
    e.target.classList.contains('exploded-view-modal')
  ){
    document
      .querySelector('.exploded-view-modal')
      ?.classList.remove('active');
  }

  if(e.target.closest('.owner-manual-popup-btn')){
    e.preventDefault();
    document
      .querySelector('.owner-manual-modal')
      ?.classList.add('active');
  }

  if(
    e.target.classList.contains('owner-manual-close') ||
    e.target.classList.contains('owner-manual-modal')
  ){
    document
      .querySelector('.owner-manual-modal')
      ?.classList.remove('active');
  }

});

  } catch(e) { console.error(e); }
})();
})();
